<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" title="精典案例" />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <div
          class="case-section-content-list"
          v-for="(cas, index) in caseList"
          :key="index"
        >
          <img v-lazy="cas.img" />
          <div
            class="content-list-abstract"
            :class="{ 'abstract-active': index % 2 != 1 }"
          >
            <p class="abstract-title">{{ cas.title }}</p>
            <div class="" v-html="cas.content"></div>
            <!-- <p class="abstract-content">{{ cas.content }}</p> -->
            <!-- <div class="more">
              <router-link
                class="text-decoration"
                :to="{ name: 'casedetails', params: { id: cas.Id } }"
              >
                <span>more</span>
                <img src="../assets/img/sanjiao.png" />
              </router-link>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner,
  },

  data() {
    return {
      loading: false,
      caseList: [
        {
          img: require("@/assets/img/case/case1.jpg"),
          title: "全球前三 - 医疗器械",
          content: `
            <div class="abstract-content">全国首套《国产电子束灭菌系统》（已取得发明专利）解决方案：数字化软件及智能包装、灭菌系统</div>
          `,
        },
        {
          img: require("@/assets/img/case/case2.jpg"),
          title: "中国四大纸业之一",
          content: `
            <div class="abstract-content">  数字化+智能化（融合）6条人工生产包装线升级为全自动产线，3台机器人码垛，在线打码、贴标，在线采集，箱码/托盘码关联追溯</div>
            <div class="abstract-content">  降本增效每班由原来的12个搬运工人，  现只需2个人负责自动码垛生产线</div>
            <div class="abstract-content">  定制傻瓜式机器人垛型操作</div>
            <div class="abstract-content">  定制WCS与现有ERP/WMS接口</div>
          `,
        },
        {
          img: require("@/assets/img/case/case3.jpg"),
          title: "全球前三  医疗器械",
          content: `
            <div class="abstract-content">数字化+智能化+信息化（融合、转化）</div>
            <div class="abstract-content">包 装的准确率，实时性，可靠性。实时数据监控、溯源可追溯</div>
            <div class="abstract-content">WCS装盒机直接无线WIFI对接AGV，效率大大提升</div>
            <div class="abstract-content">十万等级净化车间有效隔离，达到GMP标准</div>
          `,
        },
      ],
    };
  },
  mounted() {
    // window.console.log("case");
    // this.$http
    //   .get("Cases/GetCasesAll")
    //   .then(response => {
    //     //console.log(response);
    //     this.caseList = response.data;
    //     //window.console.log(this.caseList);
    //     this.loading = false;
    //   })
    //   .catch(function(error) {
    //     window.console.log(error);
    //   });
  },
};
</script>
<style lang="scss">
.abstract-content {
  // height: 150px;
  color: #14679f;
  font-size: 18px;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  // -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  white-space: normal !important;
  word-wrap: break-word;
  //border: 1px solid pink;
  &::before {
    content: "";
    width: 20px;
    display: inline-block;
  }
}
</style>

<style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 320px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            // line-height: 20px;
            font-size: 24px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #14679f;
            font-size: 18px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>
